import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getUserDesignation = createAsyncThunk('/designation/getDesignation',
    async (group) => {
        try {
            const myurl = `${PAY_URL}/user/get-designation`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const designationData = response.data;
            // console.log(designationData, "getDesignation response");

            if (designationData.success === true) {
                return designationData;
            } else {
                throw new Error(designationData.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    })

const getUserDesignationSlice = createSlice({
    name: "getUserDesignation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserDesignation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserDesignation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getUserDesignation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getUserDesignationSlice.reducer;